import { useState } from 'react'
import { Flex, Text, Dialog } from '@radix-ui/themes'
import { yenKanji } from '@/lib/price'
import { FlButton, ButtonColor } from '@/components/fl-button'
import { FlowerCollectionProduct } from '~/api-client/data-contracts'
import { styles } from './styles.css'
import check from './check.svg'

type Props = {
  product: FlowerCollectionProduct
  selected: boolean
  buttonTitle?: string
  buttonColor?: ButtonColor
  onSelect: () => any
  onUnselect: () => any
}

export const InBulkProduct: React.FC<Props> = ({ product, selected, buttonTitle = '一緒に注文する', buttonColor = 'primary', onSelect, onUnselect }) => {
  const [isOpen, setIsOpen] = useState(false)
  const isDiscounted = product.attributes.bulk_discounted_price < product.attributes.price
  const onClickSelect = () => {
    onSelect()
    setIsOpen(false)
  }

  const onClickUnselect = () => {
    onUnselect()
    setIsOpen(false)
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <Dialog.Trigger style={{ cursor: 'pointer' }} onClick={() => setIsOpen(true)}>
        <Flex key={product.id} direction="column" align="center">
          <div style={{ position: 'relative' }}>
            {isDiscounted && (
              <div className={styles.badge}>
                <Text size="2" weight="bold">
                  -20%
                </Text>
              </div>
            )}
            <img src={product.attributes.image_small_url} alt={product.attributes.name} width="100%" className={styles.thumbnail} />
            {selected && (
              <Flex className={styles.selected} direction="column" align="center" justify="center">
                <img src={check} className={styles.selectedCheck}></img>
                <Text size="2" weight="bold">
                  追加済み
                </Text>
              </Flex>
            )}
            {!product.attributes.on_sale && (
              <Flex className={styles.selected} direction="column" align="center" justify="center">
                <Text size="2" weight="bold">
                  在庫切れ
                </Text>
              </Flex>
            )}
          </div>
          <Text size="2" mt="2" style={{ color: !product.attributes.on_sale && '#ccc' }}>
            {product.attributes.name}
          </Text>
          <Text size="2" weight="bold" color={isDiscounted ? 'red' : undefined} style={{ color: !product.attributes.on_sale && '#ccc' }}>
            {yenKanji(product.attributes.bulk_discounted_price)}
          </Text>
        </Flex>
      </Dialog.Trigger>

      <Dialog.Content align="center" maxWidth="450px" aria-describedby={undefined}>
        <Flex direction="column" align="center" gap="5">
          <img src={product.attributes.image_large_url} alt={product.attributes.name} width="100%" className={styles.dialogThumbnail} />
          <Flex direction="column" align="center" gap="3">
            <Dialog.Title size="4" weight="bold" mb="0">
              {product.attributes.name}
            </Dialog.Title>
            <Flex direction="row" align="center" gap="2">
              {isDiscounted ? (
                <>
                  <Text size="2" style={{ textDecoration: 'line-through' }}>
                    {yenKanji(product.attributes.price)}
                  </Text>
                  <Text size="3" color="red" weight="bold">
                    {yenKanji(product.attributes.bulk_discounted_price)}
                  </Text>
                  <Text size="2" className={styles.discountLabel}>
                    -20%
                  </Text>
                </>
              ) : (
                <Text size="3" weight="bold">
                  {yenKanji(product.attributes.price)}
                </Text>
              )}
            </Flex>
          </Flex>
          <Dialog.Description style={{ whiteSpace: 'pre-line' }} size="2">
            {product.attributes.description}
          </Dialog.Description>
          <Flex direction="column" align="center" gap="3" width="100%">
            {selected ? (
              <FlButton color="danger" size="m" fluid onClick={onClickUnselect}>
                注文から削除
              </FlButton>
            ) : product.attributes.on_sale ? (
              <FlButton color={buttonColor} size="m" fluid onClick={onClickSelect}>
                {buttonTitle}
              </FlButton>
            ) : (
              <FlButton color="secondary" size="m" fluid disabled>
                在庫切れ
              </FlButton>
            )}
            <Dialog.Close style={{ cursor: 'pointer', padding: '4px 24px' }}>
              <Text size="2" weight="bold" color="gray">
                閉じる
              </Text>
            </Dialog.Close>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  )
}
